import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = {
  key: 0,
  class: "label"
}
const _hoisted_3 = { class: "file-select" }
const _hoisted_4 = { class: "button" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["src"]

import { ref } from "vue";

interface Props {
  modelValue?: File;
  label?: string;
  fileClass?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'file-select',
  props: {
    modelValue: {},
    label: {},
    fileClass: { default: "game-cover" }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const image = ref<string | null>(null);

const handleFileChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const file = target.files?.[0];

  if (file) {
    const reader = new FileReader();
    reader.onloadend = () => {
      image.value = reader.result as string;
    };
    reader.readAsDataURL(file);

    // Whenever the file changes, emit the 'update:modelValue' event with the file data.
    emit("update:modelValue", file);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("label", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (__props.modelValue)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Selected File: " + _toDisplayString(__props.modelValue.name), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, "Select File"))
      ]),
      _createElementVNode("input", {
        type: "file",
        onChange: handleFileChange
      }, null, 32)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['pt-5', __props.fileClass])
    }, [
      (image.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: image.value
          }, null, 8, _hoisted_7))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})